import React from "react";
import PropTypes from "prop-types";

import styles from "./ProgressBar.module.css";

const ProgressBar = ({ viewedText, totalItems, totalVisibleItems }) => {
  return (
    <div className={styles.viewTotalText}>
      {viewedText.replace("<x>", totalVisibleItems).replace("<y>", totalItems)}
      <div className={styles.progressBar}>
        <div
          style={{
            width: `${(totalVisibleItems * 100) / totalItems}%`,
          }}
          className={styles.progressBarInner}
        />
      </div>
    </div>
  );
};

export default ProgressBar;

ProgressBar.propTypes = {
  viewedText: PropTypes.string.isRequired,
  totalItems: PropTypes.number.isRequired,
  totalVisibleItems: PropTypes.number.isRequired,
};
